import axios from '../../../utils/customAxiosUtil';

import qs from 'qs';
import {
  AprvGroupData,
  GroupData,
  JoinGroupData,
  UserGroupData,
  UserGroupState
} from '../models/basisGroupModel';
// import { ReponseControlGpHistory } from '../models/controlGpModel';

export const groupAPI = {
  listMyGroup: async (data: string) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/bas/group/mylist${queryString}`);
  },
  listMyGroupJoin: async (data: string) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/bas/group/joinlist${queryString}`);
  },
  grouplist: async (data: string) => {
    const id = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/bas/group/grouplist${id}`);
  },
  detailGroup: async (id: string) => {
    return await axios.get(`api/bas/group/detail/${id}`);
  },
  createGroup: async (data: GroupData) => {
    const res = await axios.post('api/bas/group/create', data);

    return res;
  },
  updateGroup: async (data: GroupData) => {
    const res = await axios.put('api/bas/group/update', data);

    return res;
  },
  deleteGroup: async (id: string) => {
    return await axios.delete(`api/bas/group/delete/${id}`);
  },
  listGroup: async (data: string) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/bas/group/list${queryString}`);
  },
  createid: async () => {
    return await axios.get('api/bas/group/createid');
  },
  listGroupJoin: async (data: string) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/bas/group/join/list${queryString}`);
  },
  createJoinGroup: async (data: JoinGroupData) => {
    const res = await axios.post('api/bas/group/join/create', data);

    return res;
  },
  updateJoinGroup: async (data: JoinGroupData) => {
    const res = await axios.put('api/bas/group/join/update', data);

    return res;
  },
  listGroupAprv: async (data: string, page: number) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/bas/group/aprv/list${queryString}`);
  },
  updateAprvGroup: async (data: AprvGroupData) => {
    const res = await axios.put('api/bas/group/aprv/update', data);

    return res;
  },
  listGroupUser: async (data: string) => {
    const queryString = qs.stringify(data, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/bas/group/user/list${queryString}`);
  },
  updateUser: async (data: UserGroupData) => {
    const res = await axios.put('api/bas/group/user/update', data);

    return res;
  },
  delegateUser: async (data: UserGroupState) => {
    const res = await axios.put('api/bas/group/user/delegate', data);

    return res;
  }
};
